import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Просмотр спец. предложения (переводит СП на шаг 1346 (EOfferState.VIEWED))
 * @param {number} specOfferId - id спец. предложения (ISpecOffer['id'])
 *
 * {@link https://master.spec-offer.sandbox.d2c.r-one.io/docs#/%D0%A1%D0%BF%D0%B5%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5%20%D0%BF%D1%80%D0%B5%D0%B4%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F/SpecOfferReqScopedController_seen Documentation}
 */
export const view = (specOfferId: number): IRequest => ({
    uri: `/v1/spec-offers/${specOfferId}/view`,
    method: 'POST',
    withAuth: true,
    withProvider: true,
});
